import { useState } from 'react';
import { useAuthStore } from '@/stores/auth-store';

export function SettingsPanel() {
  const { user, logout } = useAuthStore();
  const [apiUrl] = useState(import.meta.env.VITE_API_URL || 'Not configured');

  return (
    <div className="h-full overflow-auto bg-background p-6">
      <h2 className="text-xl font-semibold mb-6">Settings</h2>

      <div className="space-y-6">
        {/* Account Section */}
        <section className="space-y-3">
          <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wide">Account</h3>
          <div className="glass-panel p-4 rounded-lg space-y-3">
            {user ? (
              <>
                <div className="flex items-center gap-3">
                  {user.picture && (
                    <img
                      src={user.picture}
                      alt={user.name || 'User'}
                      className="w-10 h-10 rounded-full"
                    />
                  )}
                  <div>
                    <p className="font-medium">{user.name || 'User'}</p>
                    <p className="text-sm text-muted-foreground">{user.email}</p>
                  </div>
                </div>
                <button
                  onClick={logout}
                  className="w-full mt-3 px-4 py-2 bg-red-500/10 text-red-500 rounded-lg hover:bg-red-500/20 transition-colors"
                >
                  Sign Out
                </button>
              </>
            ) : (
              <p className="text-sm text-muted-foreground">Not signed in</p>
            )}
          </div>
        </section>

        {/* API Configuration */}
        <section className="space-y-3">
          <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wide">API Configuration</h3>
          <div className="glass-panel p-4 rounded-lg">
            <div className="flex items-center justify-between">
              <span className="text-sm text-muted-foreground">API URL</span>
              <code className="text-xs bg-muted px-2 py-1 rounded">{apiUrl}</code>
            </div>
          </div>
        </section>

        {/* About */}
        <section className="space-y-3">
          <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wide">About</h3>
          <div className="glass-panel p-4 rounded-lg">
            <p className="text-sm text-muted-foreground">
              ChartZen Web v0.1.0
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}
